'use client';

import { IAtClickableProps } from '@/components/atoms';
import { OrDesignStudioBlock } from '@/components/organisms';
import { useLocation } from '@/context/locationContext';
import { IAtLinkGlobalFieldProps } from '@/lib/contentstack-sdk/types';
import {
  parseGlobalLinkFromCMS,
  parseImageFromCMS,
} from '@/lib/contentstack-sdk/utils/parseHelpers';
import { TModelHomeDetails } from './tm-home-plan-detail.types';
import { useModelHomes } from '@/hooks/useModelHomeData';
import { useEffect, useState } from 'react';
import { IHousePlanHit } from '@/lib/search/types';

export const TmHomePlanDetailDesignStudioClient = ({
  modelHomeDetails,
}: {
  modelHomeDetails: any;
}) => {
  const { currentBuildStudio } = useLocation();
  const [modelHomes, setModelHomes] = useState<IHousePlanHit[]>();

  const parseDesignStudioBlockCtaProps = (): IAtClickableProps[] =>
    ['visit_link', 'events_link']
      .filter((key) => modelHomeDetails?.[key as keyof TModelHomeDetails])
      .map(
        (key) =>
          parseGlobalLinkFromCMS(
            modelHomeDetails?.[
              key as keyof TModelHomeDetails
            ] as IAtLinkGlobalFieldProps,
            'tm-home-plan-detail',
          ) as IAtClickableProps,
      );

  const { getStudioModelHomes, loading: modelHomeLoading } = useModelHomes();

  useEffect(() => {
    if (!modelHomeLoading) {
      const homes = getStudioModelHomes(Number(currentBuildStudio?.Id));
      setModelHomes(homes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBuildStudio, modelHomeLoading]);
  return (
    <>
      {currentBuildStudio && (
        <OrDesignStudioBlock
          topSpacing="xl"
          title="See our work in person"
          ctaProps={parseDesignStudioBlockCtaProps()}
          designStudio={{
            image: parseImageFromCMS(modelHomeDetails?.image),
            Name: currentBuildStudio.CsName || currentBuildStudio.Name,
            Address: currentBuildStudio?.IsVirtual
              ? ''
              : currentBuildStudio.CsAddress || currentBuildStudio.Address,
            Id: currentBuildStudio.Id,
            City: currentBuildStudio?.IsVirtual
              ? ''
              : currentBuildStudio.CsCity || currentBuildStudio.City,
            State: currentBuildStudio?.IsVirtual
              ? ''
              : currentBuildStudio.CsState || currentBuildStudio.State,
            Zip: currentBuildStudio?.IsVirtual
              ? ''
              : currentBuildStudio.CsZip || currentBuildStudio.Zip,
            relatedModels: modelHomes,
          }}
        />
      )}
    </>
  );
};
